import { Button, Select, Switch, Input, Tooltip } from "antd";
import {
  DownloadIcon,
  FilterIcon,
  SearchIcon,
  SelectArrow,
  TickIcon,
} from "../../../../atoms/CustomIcons";
import React, { useState } from "react";
import { useAppSelector } from "../../../../config/hooks";

interface FilterProps {
  setFilters: React.Dispatch<
    React.SetStateAction<{
      type: undefined | string;
      status: undefined | string;
      state: undefined;
      city: undefined;
      onboarding_complete_date: string[] | undefined;
      last_user_activity: string[] | undefined;
      search_text: undefined | string;
    }>
  >;
  filters: {
    type: undefined | string;
    status: undefined | string;
    state: undefined;
    city: undefined;
    onboarding_complete_date: string[] | undefined;
    last_user_activity: string[] | undefined;
    search_text: undefined | string;
  };
  archived: boolean;
  isArchived: React.Dispatch<React.SetStateAction<boolean>>;
  lost: boolean;
  isLost: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function TemplateFilters(props: FilterProps) {
  const { setFilters, filters, archived, isArchived, lost, isLost } = props;
  const [showFilters, setShowFilters] = useState(false);
  // same pattern as archived
  const clientManagerList = useAppSelector(
    (state) => state?.company?.companyClientManager
  );

  const onArchivedChange = (checked: boolean) => {
    isArchived(checked);
    isLost(false);
    if (checked) {
      setFilters((prev) => ({
        ...prev,
        status: "archived",
      }));
    } else {
      setFilters((prev) => ({
        ...prev,
        status: undefined,
      }));
    }
  };

  const onLostChange = (checked: boolean) => {
    isLost(checked);
    isArchived(false);
    if (checked) {
      setFilters((prev) => ({
        ...prev,
        status: "lost",
      }));
    } else {
      setFilters((prev) => ({
        ...prev,
        status: undefined,
      }));
    }
  };

  const clearFilters = () => {
    setFilters({
      type: undefined,
      status: undefined,
      state: undefined,
      city: undefined,
      onboarding_complete_date: undefined,
      last_user_activity: undefined,
      search_text: undefined,
    });
    isArchived(false);
    isLost(false);
  };

  return (
    <div className="filtersWrapper">
      <div className="filtersTop">
        <div className="filterSearch">
          <Input
            prefix={<SearchIcon />}
            placeholder="Search potential deals"
            value={filters?.search_text}
            allowClear
            onChange={(e) =>
              setFilters((prev) => ({
                ...prev,
                search_text: e.target.value,
              }))
            }
          />
        </div>
        <div className="filterToggle">
          <Button
            icon={<FilterIcon />}
            className={`outlined-btn ${showFilters && "show_filters"} ${
              archived && "archived"
            }`}
            onClick={() => setShowFilters(!showFilters)}
          >
            Filters{" "}
            <div className="filter_icon">
              <SelectArrow />
            </div>
          </Button>
        </div>
        <div className="filterDownload">
          <Button icon={<DownloadIcon />} />
        </div>
        <div className="filterBox">
          <Tooltip title="Show deals assigned to me">
            <div className="switchBox">
              <Switch />
              Mine only
            </div>
          </Tooltip>
        </div>
      </div>
      {showFilters && (
        <div className="filtersBottom">
          <div className="btmLeft">
            <div className="filterBox">
              <Tooltip title="Property category" mouseEnterDelay={0.4}>
                <Select
                  style={{ width: "194px" }}
                  suffixIcon={<SelectArrow />}
                  menuItemSelectedIcon={
                    <TickIcon style={{ color: "#00A07D" }} />
                  }
                  showSearch
                  allowClear
                  onChange={(value) =>
                    setFilters((prev) => ({ ...prev, type: value }))
                  }
                  value={filters?.type}
                  placeholder="Property category"
                  options={[
                    {
                      value: "Option 1",
                      label: "Option 1",
                    },
                    {
                      value: "Option 2",
                      label: "Option 3",
                    },
                  ]}
                />
              </Tooltip>
            </div>
            <div className="filterBox">
              <Tooltip title="Contract type" mouseEnterDelay={0.4}>
                <Select
                  style={{ width: "194px" }}
                  suffixIcon={<SelectArrow />}
                  menuItemSelectedIcon={
                    <TickIcon style={{ color: "#00A07D" }} />
                  }
                  showSearch
                  allowClear
                  placeholder="Contract type"
                  options={[
                    {
                      value: "Option 1",
                      label: "Option 1",
                    },
                    {
                      value: "Option 2",
                      label: "Option 3",
                    },
                  ]}
                />
              </Tooltip>
            </div>
            <div className="filterBox">
              <Tooltip title="Service line" mouseEnterDelay={0.4}>
                <Select
                  style={{ width: "194px" }}
                  suffixIcon={<SelectArrow />}
                  menuItemSelectedIcon={
                    <TickIcon style={{ color: "#00A07D" }} />
                  }
                  showSearch
                  allowClear
                  placeholder="Service line"
                  options={clientManagerList}
                  mode="multiple"
                  maxTagCount={1}
                />
              </Tooltip>
            </div>
            <div className="filterBox">
              <Tooltip title="Deal status" mouseEnterDelay={0.4}>
                <Select
                  style={{ width: "194px" }}
                  suffixIcon={<SelectArrow />}
                  menuItemSelectedIcon={
                    <TickIcon style={{ color: "#00A07D" }} />
                  }
                  showSearch
                  allowClear
                  placeholder="Deal status"
                  options={clientManagerList}
                  mode="multiple"
                  maxTagCount={1}
                />
              </Tooltip>
            </div>
            <div className="filterBox">
              <Tooltip title="Probability" mouseEnterDelay={0.4}>
                <Select
                  style={{ width: "194px" }}
                  suffixIcon={<SelectArrow />}
                  menuItemSelectedIcon={
                    <TickIcon style={{ color: "#00A07D" }} />
                  }
                  showSearch
                  allowClear
                  placeholder="Probability"
                  options={clientManagerList}
                  mode="multiple"
                  maxTagCount={1}
                />
              </Tooltip>
            </div>
            <div className="filterBox">
              <Tooltip title="Responsible manager" mouseEnterDelay={0.4}>
                <Select
                  style={{ width: "194px" }}
                  suffixIcon={<SelectArrow />}
                  menuItemSelectedIcon={
                    <TickIcon style={{ color: "#00A07D" }} />
                  }
                  showSearch
                  allowClear
                  placeholder="Responsible manager"
                  options={clientManagerList}
                  mode="multiple"
                  maxTagCount={1}
                />
              </Tooltip>
            </div>
            <div className="filterBox">
              <Tooltip title="Pricing model" mouseEnterDelay={0.4}>
                <Select
                  style={{ width: "194px" }}
                  suffixIcon={<SelectArrow />}
                  menuItemSelectedIcon={
                    <TickIcon style={{ color: "#00A07D" }} />
                  }
                  showSearch
                  allowClear
                  placeholder="Pricing model"
                  options={clientManagerList}
                  mode="multiple"
                  maxTagCount={1}
                />
              </Tooltip>
            </div>
            <div className="filterBox">
              <Tooltip title="Billing model" mouseEnterDelay={0.4}>
                <Select
                  style={{ width: "194px" }}
                  suffixIcon={<SelectArrow />}
                  menuItemSelectedIcon={
                    <TickIcon style={{ color: "#00A07D" }} />
                  }
                  showSearch
                  allowClear
                  placeholder="Billing model"
                  options={clientManagerList}
                  mode="multiple"
                  maxTagCount={1}
                />
              </Tooltip>
            </div>
            <div className="filterBox">
              <Tooltip title="Type of sale" mouseEnterDelay={0.4}>
                <Select
                  style={{ width: "194px" }}
                  suffixIcon={<SelectArrow />}
                  menuItemSelectedIcon={
                    <TickIcon style={{ color: "#00A07D" }} />
                  }
                  showSearch
                  allowClear
                  placeholder="Type of sale"
                  options={clientManagerList}
                  mode="multiple"
                  maxTagCount={1}
                />
              </Tooltip>
            </div>

            <div className="filterBox">
              <div className="switchBox">
                <Switch onChange={onLostChange} checked={lost} />
                {lost ? "Hide lost" : "Show lost"}
              </div>
            </div>
            <div className="filterBox">
              <div className="switchBox">
                <Switch onChange={onArchivedChange} checked={archived} />
                {archived ? "Hide archived" : "Show archived"}
              </div>
            </div>
          </div>

          <div className="btmRight">
            <Button
              className="outlined-btn"
              onClick={clearFilters}
              disabled={!filters.type && !filters.status}
            >
              Clear filters
            </Button>
          </div>
        </div>
      )}
    </div>
  );
}
